import React from "react"

// Profile
import UserProfile from "../pages/Other/Authentication/user-profile"

// Pages Calendar
import Calendar from "../pages/Other/Calendar/index"

//Email
import EmailInbox from "../pages/Other/Email/email-inbox"
import EmailRead from "../pages/Other/Email/email-read"
import EmailCompose from "../pages/Other/Email/email-compose"

// Authentication related pages
import Login from "../pages/Other/Authentication/Login"
import Logout from "../pages/Other/Authentication/Logout"
import Register from "../pages/Other/Authentication/Register"
import ForgetPwd from "../pages/Other/Authentication/ForgetPassword"
import ResetPassword from "../pages/Other/Authentication/ResetPassword"

// Inner Authentication
import Login1 from "../pages/Other/AuthenticationInner/Login"
import Register1 from "../pages/Other/AuthenticationInner/Register"
import Recoverpw from "../pages/Other/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/Other/AuthenticationInner/auth-lock-screen"

// Dashboard
import Dashboard from "../pages/Other/Dashboard/index"
import UserStats from "../pages/Other/Dashboard/UserStats"

//Charts
import ChartsAppex from "../pages/Other/Charts/charts-appex";
import ChartsKnob from "../pages/Other/Charts/charts-knob";
import ChartsSparkLine from "../pages/Other/Charts/charts-sparkline";

// Maps
import MapsGoogle from "../pages/Other/Maps/MapsGoogle"
import MapsVector from "../pages/Other/Maps/MapsVector"

//Icons
import IconMaterialdesign from "../pages/Other/Icons/IconMaterialdesign"
import Iconion from "../pages/Other/Icons/Iconion"
import IconFontawesome from "../pages/Other/Icons/IconFontawesome"
import IconThemify from "../pages/Other/Icons/IconThemify"
import IconDripicons from "../pages/Other/Icons/IconDripicons"
import IconTypicons from "../pages/Other/Icons/IconTypicons"

//Tables
import BasicTables from "../pages/Other/Tables/BasicTables"
import DatatableTables from "../pages/Other/Tables/DatatableTables"
import ResponsiveTables from "../pages/Other/Tables/ResponsiveTables"

// Forms
import FormElements from "../pages/Other/Forms/FormElements"
import FormAdvanced from "../pages/Other/Forms/FormAdvanced"
import FormEditors from "../pages/Other/Forms/FormEditors"
import FormValidations from "../pages/Other/Forms/FormValidations"
import FormUpload from "../pages/Other/Forms/FormUpload"

//Ui
import UiAlert from "../pages/Other/Ui/UiAlert"
import UiButtons from "../pages/Other/Ui/UiButtons"
import UiBadge from "../pages/Other/Ui/UiBadge"
import UiCards from "../pages/Other/Ui/UiCards"
import UiCarousel from "../pages/Other/Ui/UiCarousel"
import UiDropdown from "../pages/Other/Ui/UiDropdown"
import UiGrid from "../pages/Other/Ui/UiGrid"
import UiImages from "../pages/Other/Ui/UiImages"
import UiLightbox from "../pages/Other/Ui/UiLightbox"
import UiModal from "../pages/Other/Ui/UiModal"
import UiPagination from "../pages/Other/Ui/UiPagination"
import UiPopoverTooltips from "../pages/Other/Ui/UiPopoverTooltips"
import UiProgressbar from "../pages/Other/Ui/UiProgressbar"
import UiTabsAccordions from "../pages/Other/Ui/UiTabsAccordions"
import UiTypography from "../pages/Other/Ui/UiTypography"
import UiVideo from "../pages/Other/Ui/UiVideo"
import UiSessionTimeout from "../pages/Other/Ui/UiSessionTimeout"
import UiRangeSlider from "../pages/Other/Ui/UiRangeSlider"

//Extra Pages
import PagesTimeline from "../pages/Other/Extra Pages/pages-timeline";
import PagesInvoice from "../pages/Other/Extra Pages/pages-invoice";
import PagesDirectory from "../pages/Other/Extra Pages/pages-directory";
import PagesBlank from "../pages/Other/Extra Pages/pages-blank";
import Pages404 from "../pages/Other/Extra Pages/pages-404";
import Pages500 from "../pages/Other/Extra Pages/pages-500";
import UiUtilities from "../pages/Other/Ui/UiUtilities"
import UiColors from "../pages/Other/Ui/UiColors"
import UiOffcanvas from "../pages/Other/Ui/UiOffcanvas"
import Chat from "../pages/Other/Chat/Chat";
import Kanban from "../pages/Other/Kanban"
import Home from "../pages/Home/Home"
import Properties from "../pages/Home/Properties"
import PropertyDetail from "../pages/Home/Properties/PropertyDetail"
import Seller from "../pages/Home/Seller"
import Broker from "../pages/Home/Broker"
import LiveAuction from "../pages/Home/LiveAuction"
import SubscriptionComingSoon from "../pages/Home/Subscription"
import TermsAndConditions from "../pages/Home/Legal/TermsAndConditions"
import PrivacyPolicy from "../pages/Home/Legal/PrivacyPolicy"
import AboutUs from "../pages/Home/Legal/AboutUs"
import ContactUs from "../pages/Home/ContactUs"
import CrmList from "../pages/Adminside/Crm/CrmList"
import CreateCrm from "../pages/Adminside/Crm/CreateCrm"
import LiveProperties from "../pages/Home/Properties/LiveProperties/LiveProperties"
import ListProperty from "../pages/Adminside/Listings/CreateListProperty"
import Listings from "../pages/Adminside/Listings/Listings"
import BidProperty from "../pages/Bidding/BidProperty"
import BidList from "../pages/Bidding/BidList"
import MyBids from "../pages/Bidding/MyBids"
import BiddingOverview from "../pages/Adminside/Bidding/BiddingOverview"
import ClosedBiddingPage from "../pages/Other/Dashboard/ClosedBiddingPage"

import UsersKyc from "../pages/Adminside/Maters/Users/Users"
import AddUser from "../pages/Adminside/Maters/Users/AddUser"
import Buyer from "../pages/Home/Buyer"

interface RouteConfig {
  path: string
  component: React.ReactElement
  exact?: boolean
}

// Public / global routes (no dashboard layout, no sidebar)
const publicRoutes: RouteConfig[] = [
  { path: "/", component: <Home /> },
  { path: "/properties", component: <Properties /> },
  { path: "/property/:id", component: <PropertyDetail /> },
  { path: "/buyer", component: <Buyer /> },
  { path: "/seller", component: <Seller /> },
  { path: "/broker", component: <Broker /> },
  { path: "/live-auction", component: <LiveAuction /> },
  { path: "/subscription", component: <SubscriptionComingSoon /> },
  { path: "/terms-and-conditions", component: <TermsAndConditions /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/about-us", component: <AboutUs /> },
  { path: "/contact-us", component: <ContactUs /> },
]

const userRoutes: RouteConfig[] = [

  { path: "/dashboard", component: <Dashboard /> },
  { path: "/user-stats", component: <UserStats /> },

  { path: "/crm", component: <CrmList /> },
  { path: "/crm/create", component: <CreateCrm /> },
  { path: "/crm/:id", component: <CreateCrm /> },

  { path: "/live-properties", component: <LiveProperties /> },

  { path: "/list-property", component: <ListProperty /> },
  { path: "/list-property/:id", component: <ListProperty /> },
  { path: "/listings", component: <Listings /> },
  { path: "/bidding-overview", component: <BiddingOverview /> },
  { path: "/closed-bidding", component: <ClosedBiddingPage /> },
  { path: "/bid/:listingId", component: <BidProperty /> },
  { path: "/bid", component: <BidList /> },
  { path: "/my-bids", component: <MyBids /> },

  { path: "/users", component: <UsersKyc /> },
  { path: "/users/add", component: <AddUser /> },
  { path: "/users/edit/:id", component: <AddUser /> },

  // //calendar
  { path: "/calendar", component: <Calendar /> },

  { path: "/chat", component: <Chat /> },
  { path: "/kanbanboard", component: <Kanban /> },

  // // //profile
  { path: "/profile", component: <UserProfile /> },

  // //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read", component: <EmailRead /> },
  { path: "/email-compose", component: <EmailCompose /> },

  // //Charts
  { path: "/apex-charts", component: <ChartsAppex /> },
  { path: "/charts-knob", component: <ChartsKnob /> },
  { path: "/sparkline-charts", component: <ChartsSparkLine /> },

  // // Icons
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-ion", component: <Iconion /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },
  { path: "/icons-themify", component: <IconThemify /> },
  { path: "/icons-dripicons", component: <IconDripicons /> },
  { path: "/icons-typicons", component: <IconTypicons /> },

  // // Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-datatable", component: <DatatableTables /> },
  { path: "/tables-responsive", component: <ResponsiveTables /> },

  // // Maps
  { path: "/maps-google", component: <MapsGoogle /> },
  { path: "/maps-vector", component: <MapsVector /> },

  // // Forms
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editors", component: <FormEditors /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-validation", component: <FormValidations /> },

  // // Ui
  { path: "/ui-alerts", component: <UiAlert /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-badge", component: <UiBadge /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModal /> },
  { path: "/ui-pagination", component: <UiPagination /> },
  { path: "/ui-popover-tooltip", component: <UiPopoverTooltips /> },
  { path: "/ui-progressbars", component: <UiProgressbar /> },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  { path: "/ui-utilities", component: <UiUtilities /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },

  // //Extra Pages
  { path: "/pages-timeline", component: <PagesTimeline /> },
  { path: "/pages-invoice", component: <PagesInvoice /> },
  { path: "/pages-directory", component: <PagesDirectory /> },
  { path: "/pages-blank", component: <PagesBlank /> },
]

const authRoutes: RouteConfig[] = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
]

export { publicRoutes, userRoutes, authRoutes }